import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordinal',
    standalone: true
})
export class OrdinalPipe implements PipeTransform {
    transform = ordinal;
}

export function ordinal(input: string | number | null | undefined, hideDay?: boolean): string {
    if (!input) {
        return '';
    }
    const num = typeof input === 'string' ? parseInt(input, 10) : input;
    const s = ['th', 'st', 'nd', 'rd'];
    const v = num % 100;
    const o = s[(v - 20) % 10] || s[v] || s[0];
    return (hideDay ? '' : input) + o;
}
